export default "__VITE_ASSET__8f0BS_V2__"